module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ( _obj = {}, _obj[_vm.settingsLinkActiveClass] = ['StorekeepersFreights', 'StorekeepersFreights'].indexOf(_vm.settingLink) + 1, _obj ),
    attrs: {
      "to": {
        name: 'StorekeepersFreights'
      }
    }
  }, [_c('md-icon', [_vm._v("view_stream")]), _vm._v(" "), _c('span', [_vm._v("Грузы")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27227155","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/menus/MainMenu.vue
// module id = 1077
// module chunks = 0